import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ButtonCustom from '../../../../../../Components/ButtonCustom'
import { Box } from '../../../../../../Components/CustomUi/box'
import { Inline } from '../../../../../../Components/CustomUi/inline'
import Input from '../../../../../../Components/CustomUi/input'
import { ItensPerUserLogged } from '../../../../../../services/login/permissaoUsuarioLoado'
import { removerAcentos } from '../../../../../../utils'
import { faCopy, faEdit, faEye, faPlus } from '@fortawesome/free-solid-svg-icons'
import { HeaderTable } from '../../../../../../Components/CustomUi/table/headerTable'
import { BodyTable } from '../../../../../../Components/CustomUi/table/bodyTable'
import { Render } from '../../../../../../Components/CustomUi/render'
import { RowTable } from '../../../../../../Components/CustomUi/table/rowTable'
import { RowItem } from '../../../../../../Components/CustomUi/table/rowItem'
import { Empty, Tag } from 'antd'
import { DeleteButton } from '../../../../../../Components/CustomUi/deleteButton'
import Carregando from '../../../../../../Components/CustomUi/loading'

interface Props {
  loading: boolean
  list_adjuvantes: any[]
  deletar: Function
  abrir: Function
  editar: Function
  duplicar: Function
  permissions?: ItensPerUserLogged
  setPagination: React.Dispatch<React.SetStateAction<number>>
  page: number
  setPage: React.Dispatch<React.SetStateAction<number>>
  buscarTabela: string
  setBuscarTabela: React.Dispatch<React.SetStateAction<string>>
  total: number
  confirmar_exclusao: boolean
  setConfirmar_exclusao: React.Dispatch<React.SetStateAction<boolean>>
  id_item_atual: number
  setId_item_atual: React.Dispatch<React.SetStateAction<number>>
  nome_item_atual: string
  setNome_item_atual: React.Dispatch<React.SetStateAction<string>>
  fake_loading: boolean
  setFake_loading: React.Dispatch<React.SetStateAction<boolean>>
}

export const TabelaAdjuvantes: React.FC<Props> = ({
  list_adjuvantes,
  loading,
  deletar,
  abrir,
  setPagination,
  editar,
  duplicar,
  page,
  setPage,
  buscarTabela,
  setBuscarTabela,
  total,
  confirmar_exclusao,
  setConfirmar_exclusao,
  id_item_atual,
  setId_item_atual,
  nome_item_atual,
  setNome_item_atual,
  fake_loading,
  setFake_loading,
  permissions,
}) => {
  function buscarAdjuvantes(buscar_nome: string) {
    const palavraSemAcentos = removerAcentos(buscar_nome)
    return function (item) {
      const nomeSemAcentos = removerAcentos(String(item?.nome))
      return nomeSemAcentos.toLowerCase().includes(palavraSemAcentos.toLowerCase()) || !buscar_nome
    }
  }

  return (
    <Box style={{ height: 'calc(100vh - 170px)', border: 'none' }} padding={0} borderless>
      {/* <TitleH2>Lista de patrimônios</TitleH2> */}

      <Inline alignItems='center'>
        <Input placeholder='Buscar insumos' value={buscarTabela} onChange={setBuscarTabela} />
        <ButtonCustom icon={<FontAwesomeIcon icon={faPlus} />} onClick={abrir}>
          Novo
        </ButtonCustom>
      </Inline>

      <HeaderTable
        itens={[
          { valor: 'Nome', width: 'calc(100% - 850px)' },
          { valor: 'Fabricante', width: '200px' },
          { valor: 'Categoria', width: '200px' },
          { valor: 'Culturas', width: '250px' },
          { valor: 'Ações', width: '200px' },
        ]}
      />

      <BodyTable
        paginate={total}
        onChangeItensPage={setPagination}
        onChangePage={setPage}
        current_page={page}
        setCurrent_page={setPage}
        style={{
          height: 'calc(100vh - 170px)',
          // height: (list_adjuvantes ?? []).length < 8 && 'calc(100vh - 170px)',
          position: 'relative',
          overflowX: 'hidden',
          overflowY: 'scroll',
          marginTop: -10,
        }}
      >
        <Render condition={!loading}>
          {(list_adjuvantes ?? [])
            .filter(buscarAdjuvantes(buscarTabela))
            .map(
              (
                { cod, nome, fabricante_nome, categoria_produto_nome, composicao, doses },
                index
              ) => {
                return (
                  <RowTable key={cod} onDoubleClick={() => editar(cod)} style={{ height: 'auto' }}>
                    <RowItem fontSize={13} width={'calc(100% - 844px)'}>
                      {nome}
                    </RowItem>
                    <RowItem fontSize={13} width={'200px'}>
                      {fabricante_nome}
                    </RowItem>
                    <RowItem fontSize={13} width={'200px'}>
                      {categoria_produto_nome}
                    </RowItem>
                    <RowItem
                      fontSize={13}
                      width={'249.5px'}
                      style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        justifyContent: 'flex-start',
                        alignContent: 'center',
                      }}
                    >
                      {doses?.map((tag) => {
                        return (
                          <Tag
                            color='green'
                            key={tag.cod}
                            style={{ margin: 5, fontSize: '10px', whiteSpace: 'normal' }}
                          >
                            {tag.cultura_nome.toUpperCase()}
                          </Tag>
                        )
                      })}
                    </RowItem>
                    <RowItem width={'200px'} gap={10}>
                      <DeleteButton
                        open={confirmar_exclusao && id_item_atual === cod}
                        trigger={setConfirmar_exclusao}
                        onTrigger={() => {
                          setId_item_atual(cod)
                          setNome_item_atual(nome)
                        }}
                        loading={fake_loading}
                        message={`o item ${nome} será excluido!`}
                        deleteds={[nome]}
                        onDelete={() => {
                          deletar(cod)
                        }}
                        disabled={fake_loading || permissions?.acesso === 1}
                        hidden={permissions?.acesso === 1}
                        typeButtonTrigger='tertiary'
                      />

                       <ButtonCustom
                      icon={<FontAwesomeIcon icon={faCopy} />}
                      onClick={() => duplicar(cod)}
                      hidden={permissions?.acesso === 1}
                      type='secondary'
                    />
                      <ButtonCustom
                        icon={<FontAwesomeIcon icon={permissions?.acesso === 1 ? faEye : faEdit} />}
                        onClick={() => {
                          editar(cod)
                        }}
                        disabled={permissions?.acesso === 1 && permissions?.alteracao === 0}
                      >
                        {permissions?.acesso === 1 ? 'Ver' : 'Editar'}
                      </ButtonCustom>
                    </RowItem>
                  </RowTable>
                )
              }
            )}
        </Render>

        <Render condition={list_adjuvantes?.length === 0 && !loading}>
          {buscarTabela === '' ? (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={<> Nenhum registro disponível!</>}
            />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={
                <>
                  {' '}
                  <b>'{buscarTabela}'</b> não encontrado!
                </>
              }
            />
          )}
        </Render>

        <Render condition={loading}>
          <Carregando
            animation
            legenda='Carregando adjuvante...'
            justifyContent='center'
            height={400}
            size='default'
          />
        </Render>
      </BodyTable>
    </Box>
  )
}
